exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  position: relative;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  overflow: hidden;\n  border-radius: 25%; }\n  :host-context(header-bar) div {\n    width: 41px;\n    height: 41px;\n    border: 3px solid transparent; }\n    :host-context(header-bar) div[style] {\n      border-color: white; }\n    :host-context(header-bar) div:before {\n      line-height: 35px;\n      font-size: 35px; }\n\n:before {\n  display: block;\n  text-align: center;\n  line-height: 30px;\n  font-size: 30px; }\n\n[style]:after {\n  content: '';\n  display: block;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: inherit; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/user-avatar/user-avatar.scss
// module id = ../../../../../src/app/components/user-avatar/user-avatar.scss
// module chunks = 1